import { createApp } from 'vue'
import MarkdownEditor from '../components/markdown_editor'
import dataPropsParser from '../data_props_parser'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName('vue-markdown')

  Array.prototype.forEach.call(elements, element => {
    const dataProps = dataPropsParser(element.dataset.props)
    const app = createApp(MarkdownEditor, dataProps)
    app.mount(`#${element.id}`)
  })
})
